import {createContext} from 'react';

export const AppStorage = createContext({
  connected: true,
});
